/**
 * Built-in page templates.
 *
 * Each template has:
 *   id          — unique string
 *   name        — display name
 *   description — short description shown in the panel
 *   thumbnail   — inline SVG or image URL used as preview
 *   sections    — the raw sections array (header + content + footer stripped;
 *                 HomepageTab will re-wrap with the global header/footer)
 *
 * The `sections` array should NOT include a header or footer section —
 * those are always taken from the global layout when the template is applied.
 */

// ─── Template 1: Webinar Conference Landing Page ──────────────────────────────
const webinarConference = {
  id: 'webinar-conference',
  name: 'Webinar Conference',
  description: 'Hero section with countdown timer, speakers grid, agenda, and CTA banner.',
  sections: [
    {
      "id": "uda2k8d",
      "label": "Hero",
      "elements": [
        {
          "id": "kdw0cm7",
          "type": "container",
          "orientation": "row",
          "children": [
            {
              "id": "wkc5smq",
              "type": "container",
              "orientation": "column",
              "children": [
                {
                  "id": "wuqnz2f",
                  "type": "container",
                  "orientation": "row",
                  "children": [
                    {
                      "id": "bh06lrn",
                      "type": "button",
                      "label": "Live in 12 Days",
                      "href": "#",
                      "style": {
                        "background": "#ffffff",
                        "color": "#236ec3",
                        "borderRadius": "20px",
                        "padding": "5px 20px 5px 20px",
                        "fontSize": "11px",
                        "fontWeight": "700",
                        "border": "1px solid lightgrey",
                        "width": "150px",
                        "marginRight": "100px"
                      }
                    }
                  ],
                  "style": {
                    "padding": "0px 0px 0px 0px",
                    "background": "transparent",
                    "borderRadius": "8px",
                    "display": "flex",
                    "flexDirection": "row",
                    "justifyContent": "center",
                    "alignItems": "space-between",
                    "alignSelf": "stretch",
                    "gap": "5px"
                  }
                },
                {
                  "id": "9mi6owh",
                  "type": "text",
                  "content": "Webinar Event 2026",
                  "style": {
                    "fontSize": "80px",
                    "color": "#1d5fbe",
                    "fontWeight": "700",
                    "lineHeight": "1"
                  },
                  "responsiveStyles": { "mobile": { "fontSize": "60px" } }
                },
                {
                  "id": "3x6qjy6",
                  "type": "text",
                  "content": "Join 5,000+ visionaries at the intersection of high-fidelity tech and late-night digital culture.",
                  "style": {
                    "fontSize": "16px",
                    "color": "#546a85",
                    "fontWeight": "600",
                    "lineHeight": "1.2",
                    "padding": "0px 0px 0px 0px"
                  }
                },
                {
                  "id": "azmhqmv",
                  "type": "container",
                  "orientation": "row",
                  "children": [
                    {
                      "id": "tjpnzlh",
                      "type": "button",
                      "label": "REGISTER NOW",
                      "href": "#",
                      "style": {
                        "background": "#1075BA",
                        "color": "#fff",
                        "borderRadius": "20px",
                        "padding": "10px 30px 10px 30px",
                        "fontSize": "14px",
                        "fontWeight": "700",
                        "width": "100%"
                      }
                    },
                    {
                      "id": "dt78st8",
                      "type": "container",
                      "orientation": "column",
                      "children": [
                        {
                          "id": "yrbfx8e",
                          "type": "text",
                          "content": "EVENT DATES",
                          "style": { "fontSize": "11px", "color": "#ababab", "fontWeight": "600", "lineHeight": "1", "padding": "0px" }
                        },
                        {
                          "id": "8xmmrzz",
                          "type": "text",
                          "content": "November 24 — November 27, 2026",
                          "style": { "fontSize": "11px", "color": "#1a1a2e", "fontWeight": "600", "lineHeight": "1", "padding": "0px", "width": "200px" }
                        }
                      ],
                      "style": {
                        "padding": "0px",
                        "minHeight": "60px",
                        "background": "transparent",
                        "borderRadius": "4px",
                        "display": "flex",
                        "flexDirection": "column",
                        "justifyContent": "center",
                        "alignItems": "stretch",
                        "alignSelf": "stretch",
                        "gap": "0px"
                      }
                    }
                  ],
                  "style": {
                    "padding": "5px",
                    "background": "transparent",
                    "borderRadius": "8px",
                    "display": "flex",
                    "flexDirection": "row",
                    "justifyContent": "center",
                    "alignItems": "flex-start",
                    "alignSelf": "stretch",
                    "gap": "16px"
                  },
                  "responsiveStyles": { "mobile": { "flexDirection": "column", "alignItems": "center" } }
                }
              ],
              "style": {
                "padding": "5px",
                "background": "transparent",
                "borderRadius": "8px",
                "display": "flex",
                "flexDirection": "column",
                "justifyContent": "center",
                "alignItems": "stretch",
                "alignSelf": "stretch"
              }
            },
            {
              "id": "0ct2vsy",
              "type": "container",
              "orientation": "column",
              "children": [
                {
                  "id": "264uony",
                  "type": "container",
                  "orientation": "column",
                  "children": [
                    {
                      "id": "usyn4pf",
                      "type": "text",
                      "content": "Countdown\n",
                      "style": { "fontSize": "13px", "color": "#1565c4", "fontWeight": "700", "lineHeight": "1.2", "padding": "0px" }
                    },
                    {
                      "id": "ep8hc14",
                      "type": "countdown",
                      "targetDate": "2026-06-07T06:28",
                      "layout": "2x2",
                      "show": {
                        "days": true,
                        "hours": true,
                        "mins": true,
                        "secs": true
                      },
                      "numberSize": "48px",
                      "labelSize": "13px",
                      "numberColor": "#1a1a2e",
                      "labelColor": "#7a8494",
                      "cardBackground": "#f1f5f9",
                      "cardRadius": "12px",
                      "cardHeight": "",
                      "style": {}
                    }
                  ],
                  "style": {
                    "padding": "25px",
                    "background": "#ffffff",
                    "borderRadius": "20px",
                    "display": "flex",
                    "flexDirection": "column",
                    "justifyContent": "center",
                    "alignItems": "stretch",
                    "alignSelf": "stretch",
                    "boxShadow": "3px 4px 29px 0px #abb9ce"
                  }
                }
              ],
              "style": {
                "padding": "5px",
                "background": "transparent",
                "borderRadius": "8px",
                "display": "flex",
                "flexDirection": "column",
                "justifyContent": "center",
                "alignItems": "stretch",
                "alignSelf": "stretch"
              }
            }
          ],
          "style": {
            "padding": "20px 0px",
            "background": "transparent",
            "borderRadius": "8px",
            "display": "flex",
            "flexDirection": "row",
            "justifyContent": "center",
            "alignItems": "stretch",
            "alignSelf": "stretch"
          },
          "responsiveStyles": { "tablet": { "flexDirection": "column" }, "mobile": { "flexDirection": "column" } }
        }
      ],
      "style": { "padding": "10px", "background": "linear-gradient(141deg, rgba(237,242,250,1) 0%, rgba(220,227,242,1) 77%)" },
      "type": "section",
      "visibleOn": { "desktop": true, "tablet": true, "mobile": true },
      "layout": "boxed",
      "maxWidth": "1100px"
    },
    {
      "id": "rmuuw50",
      "label": "Speakers",
      "elements": [
        {
          "id": "7cinwtu",
          "type": "container",
          "orientation": "column",
          "children": [
            { "id": "imkpr1s", "type": "text", "content": "THE LINEUP", "style": { "fontSize": "13px", "color": "#1565c4", "fontWeight": "700", "lineHeight": "1.2", "padding": "0px" } },
            { "id": "yj9stt4", "type": "text", "content": "Keynote Visionaries", "style": { "fontSize": "50px", "color": "#121212", "fontWeight": "600", "lineHeight": "1", "marginBottom": "20px" }, "responsiveStyles": { "mobile": { "fontSize": "50px" } } },
            {
              "id": "lzor0kv",
              "type": "container",
              "orientation": "row",
              "children": [
                {
                  "id": "5lq3uru",
                  "type": "container",
                  "orientation": "column",
                  "children": [
                    { "id": "xqka14k", "type": "text", "content": "Dr. Elena Voss", "style": { "fontSize": "20px", "color": "#ffffff", "fontWeight": "700" } },
                    { "id": "2fenyb4", "type": "text", "content": "Head of Marketing", "style": { "fontSize": "16px", "color": "#ffffff", "fontWeight": "600" } }
                  ],
                  "style": { "padding": "20px", "background": "url('https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80') center/cover no-repeat", "borderRadius": "8px", "display": "flex", "flexDirection": "column", "justifyContent": "flex-end", "alignItems": "stretch", "alignSelf": "stretch", "overlayBackground": "rgba(0,0,0,0.4)", "gap": "0px", "height": "300px" }
                },
                {
                  "id": "160d8dp",
                  "type": "container",
                  "orientation": "column",
                  "children": [
                    { "id": "guyyorf", "type": "text", "content": "Marcus Thorne", "style": { "fontSize": "20px", "color": "#ffffff", "fontWeight": "700" } },
                    { "id": "f0lzmnx", "type": "text", "content": "CTO", "style": { "fontSize": "16px", "color": "#ffffff", "fontWeight": "600" } }
                  ],
                  "style": { "padding": "20px", "background": "url('https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&q=80') center/cover no-repeat", "borderRadius": "8px", "display": "flex", "flexDirection": "column", "justifyContent": "flex-end", "alignItems": "stretch", "alignSelf": "stretch", "overlayBackground": "rgba(0,0,0,0.4)", "gap": "0px", "height": "300px" }
                },
                {
                  "id": "tg48pa1",
                  "type": "container",
                  "orientation": "column",
                  "children": [
                    { "id": "9l0spih", "type": "text", "content": "Sacha Chen", "style": { "fontSize": "20px", "color": "#ffffff", "fontWeight": "700" } },
                    { "id": "pbtqhml", "type": "text", "content": "Head of Marketing", "style": { "fontSize": "16px", "color": "#ffffff", "fontWeight": "600" } }
                  ],
                  "style": { "padding": "20px", "background": "url('https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80') center/cover no-repeat", "borderRadius": "8px", "display": "flex", "flexDirection": "column", "justifyContent": "flex-end", "alignItems": "stretch", "alignSelf": "stretch", "overlayBackground": "rgba(0,0,0,0.4)", "gap": "0px", "height": "300px" }
                },
                {
                  "id": "3ktzglu",
                  "type": "container",
                  "orientation": "column",
                  "children": [
                    { "id": "9bu58ss", "type": "text", "content": "David Sterling", "style": { "fontSize": "20px", "color": "#ffffff", "fontWeight": "700" } },
                    { "id": "h51567r", "type": "text", "content": "CEO", "style": { "fontSize": "16px", "color": "#ffffff", "fontWeight": "600" } }
                  ],
                  "style": { "padding": "20px", "background": "url('https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&q=80') center/cover no-repeat", "borderRadius": "8px", "display": "flex", "flexDirection": "column", "justifyContent": "flex-end", "alignItems": "stretch", "alignSelf": "stretch", "overlayBackground": "rgba(0,0,0,0.4)", "gap": "0px", "height": "300px" }
                }
              ],
              "style": { "padding": "5px", "background": "transparent", "borderRadius": "8px", "display": "flex", "flexDirection": "row", "justifyContent": "center", "alignItems": "stretch", "alignSelf": "stretch" },
              "responsiveStyles": { "mobile": { "flexDirection": "column" } }
            }
          ],
          "style": { "padding": "5px", "background": "transparent", "borderRadius": "8px", "display": "flex", "flexDirection": "column", "justifyContent": "center", "alignItems": "stretch", "alignSelf": "stretch", "gap": "0px" }
        }
      ],
      "style": { "padding": "50px 15px", "background": "#f5f7fa", "minHeight": "200px" },
      "type": "section",
      "layout": "boxed",
      "maxWidth": "1100px"
    },
    {
      "id": "9lu3xqb",
      "label": "Agenda",
      "elements": [
        {
          "id": "mjihjym",
          "type": "container",
          "orientation": "column",
          "children": [
            { "id": "dm6s4b7", "type": "text", "content": "THE AGENDA", "style": { "fontSize": "13px", "color": "#1565c4", "fontWeight": "700", "lineHeight": "1.2", "padding": "0px", "textAlign": "center" } },
            { "id": "hp6cu0v", "type": "text", "content": "FULL SCHEDULE", "style": { "fontSize": "50px", "color": "#121212", "fontWeight": "600", "lineHeight": "1", "marginBottom": "20px", "textAlign": "center" }, "responsiveStyles": { "mobile": { "fontSize": "50px" } } },
            { "id": "d1p4yds", "type": "text", "content": "Click the button below to check out the full event schedule.", "style": { "fontSize": "16px", "color": "#1a1a2e", "fontWeight": "400", "textAlign": "center" } }
          ],
          "style": { "padding": "5px", "background": "transparent", "borderRadius": "8px", "display": "flex", "flexDirection": "column", "justifyContent": "center", "alignItems": "stretch", "alignSelf": "stretch" }
        },
        {
          "id": "dwxrsfy",
          "type": "container",
          "orientation": "column",
          "children": [
            { "id": "2pzgw7p", "type": "button", "label": "Download the PDF Schedule", "href": "#", "style": { "background": "#f2f2f2", "color": "#050505", "borderRadius": "20px", "padding": "10px 24px", "fontSize": "14px", "fontWeight": "500", "border": "1px solid lightgrey" } }
          ],
          "style": { "padding": "15px 5px 5px 5px", "background": "transparent", "borderRadius": "8px", "display": "flex", "flexDirection": "column", "justifyContent": "center", "alignItems": "center", "alignSelf": "stretch" }
        }
      ],
      "style": { "padding": "60px 15px", "background": "#fff", "minHeight": "200px" },
      "type": "section",
      "layout": "boxed",
      "maxWidth": "1100px"
    },
    {
      "id": "btmjp2w",
      "label": "CTA Banner",
      "elements": [
        {
          "id": "nlly29k",
          "type": "container",
          "orientation": "column",
          "children": [
            {
              "id": "qm356nj",
              "type": "container",
              "orientation": "column",
              "children": [
                { "id": "kf2dqhl", "type": "text", "content": "READY TO STEP INTO THE LIGHT?", "style": { "fontSize": "60px", "color": "#ffffff", "fontWeight": "700", "lineHeight": "1", "textAlign": "center" }, "responsiveStyles": { "mobile": { "fontSize": "60px" } } },
                { "id": "9m9on0e", "type": "text", "content": "Join 5,000+ visionaries at the intersection of high-fidelity tech and late-night digital culture.", "style": { "fontSize": "16px", "color": "#ffffff", "fontWeight": "600", "lineHeight": "1.2", "padding": "0px" } },
                { "id": "d6r0bvg", "type": "button", "label": "REGISTER NOW", "href": "#", "style": { "background": "#1075BA", "color": "#fff", "borderRadius": "20px", "padding": "10px 30px", "fontSize": "14px", "fontWeight": "700", "width": "100%" } }
              ],
              "style": { "padding": "5px", "background": "transparent", "borderRadius": "8px", "display": "flex", "flexDirection": "column", "justifyContent": "center", "alignItems": "center", "alignSelf": "stretch" }
            }
          ],
          "style": { "padding": "80px", "background": "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)", "borderRadius": "8px", "display": "flex", "flexDirection": "column", "justifyContent": "center", "alignItems": "stretch", "alignSelf": "stretch", "overlayBackground": "rgba(0,0,0,0.4)" },
          "responsiveStyles": { "mobile": { "padding": "40px" } }
        }
      ],
      "style": { "padding": "0px", "background": "#ffffff", "minHeight": "200px" },
      "type": "section",
      "layout": "full",
      "maxWidth": "1000px"
    }
  ],
};

// ─── Template 2: Minimal Event Landing Page ───────────────────────────────────
const minimalEvent = {
  id: 'minimal-event',
  name: 'Minimal Event',
  description: 'Clean centered hero with title, date, and a single register CTA.',
  sections: [
    {
      "id": "min-hero",
      "label": "Hero",
      "elements": [
        {
          "id": "min-c1",
          "type": "container",
          "orientation": "column",
          "children": [
            {
              "id": "min-badge",
              "type": "button",
              "label": "Upcoming Event",
              "href": "#",
              "style": { "background": "#eef4ff", "color": "#1d5fbe", "borderRadius": "20px", "padding": "6px 18px", "fontSize": "12px", "fontWeight": "700", "border": "1px solid #c7d9f8", "width": "fit-content" }
            },
            { "id": "min-t1", "type": "text", "content": "Your Event Title", "style": { "fontSize": "72px", "color": "#0f172a", "fontWeight": "800", "lineHeight": "1", "textAlign": "center" }, "responsiveStyles": { "mobile": { "fontSize": "44px" } } },
            { "id": "min-t2", "type": "text", "content": "A world-class gathering of innovators, creators, and leaders.", "style": { "fontSize": "18px", "color": "#64748b", "fontWeight": "400", "lineHeight": "1.6", "textAlign": "center", "maxWidth": "560px" } },
            { "id": "min-t3", "type": "text", "content": "November 24 – 27, 2026  ·  Manila, Philippines", "style": { "fontSize": "14px", "color": "#94a3b8", "fontWeight": "600", "textAlign": "center", "letterSpacing": "0.05em" } },
            {
              "id": "min-btns",
              "type": "container",
              "orientation": "row",
              "children": [
                { "id": "min-b1", "type": "button", "label": "Register Now →", "href": "#", "style": { "background": "#1075BA", "color": "#fff", "borderRadius": "12px", "padding": "14px 32px", "fontSize": "15px", "fontWeight": "700" } },
              ],
              "style": { "padding": "0px", "background": "transparent", "borderRadius": "0px", "display": "flex", "flexDirection": "row", "justifyContent": "center", "alignItems": "center", "alignSelf": "stretch", "gap": "12px" },
              "responsiveStyles": { "mobile": { "flexDirection": "column" } }
            }
          ],
          "style": { "padding": "20px", "background": "transparent", "borderRadius": "8px", "display": "flex", "flexDirection": "column", "justifyContent": "center", "alignItems": "center", "alignSelf": "stretch", "gap": "20px" }
        }
      ],
      "style": { "padding": "100px 20px", "background": "#f8fafc", "minHeight": "500px" },
      "type": "section",
      "layout": "boxed",
      "maxWidth": "800px"
    },
    {
      "id": "min-stats",
      "label": "Stats",
      "elements": [
        {
          "id": "min-sc",
          "type": "container",
          "orientation": "row",
          "children": [
            {
              "id": "min-s1",
              "type": "container",
              "orientation": "column",
              "children": [
                { "id": "min-s1n", "type": "text", "content": "5,000+", "style": { "fontSize": "40px", "color": "#0f172a", "fontWeight": "800", "lineHeight": "1", "textAlign": "center" } },
                { "id": "min-s1l", "type": "text", "content": "Attendees", "style": { "fontSize": "14px", "color": "#64748b", "fontWeight": "500", "textAlign": "center" } }
              ],
              "style": { "padding": "30px 20px", "background": "transparent", "borderRadius": "8px", "display": "flex", "flexDirection": "column", "justifyContent": "center", "alignItems": "center", "alignSelf": "stretch", "gap": "6px" }
            },
            {
              "id": "min-s2",
              "type": "container",
              "orientation": "column",
              "children": [
                { "id": "min-s2n", "type": "text", "content": "80+", "style": { "fontSize": "40px", "color": "#0f172a", "fontWeight": "800", "lineHeight": "1", "textAlign": "center" } },
                { "id": "min-s2l", "type": "text", "content": "Speakers", "style": { "fontSize": "14px", "color": "#64748b", "fontWeight": "500", "textAlign": "center" } }
              ],
              "style": { "padding": "30px 20px", "background": "transparent", "borderRadius": "8px", "display": "flex", "flexDirection": "column", "justifyContent": "center", "alignItems": "center", "alignSelf": "stretch", "gap": "6px" }
            },
            {
              "id": "min-s3",
              "type": "container",
              "orientation": "column",
              "children": [
                { "id": "min-s3n", "type": "text", "content": "4 Days", "style": { "fontSize": "40px", "color": "#0f172a", "fontWeight": "800", "lineHeight": "1", "textAlign": "center" } },
                { "id": "min-s3l", "type": "text", "content": "Of Content", "style": { "fontSize": "14px", "color": "#64748b", "fontWeight": "500", "textAlign": "center" } }
              ],
              "style": { "padding": "30px 20px", "background": "transparent", "borderRadius": "8px", "display": "flex", "flexDirection": "column", "justifyContent": "center", "alignItems": "center", "alignSelf": "stretch", "gap": "6px" }
            },
            {
              "id": "min-s4",
              "type": "container",
              "orientation": "column",
              "children": [
                { "id": "min-s4n", "type": "text", "content": "20+", "style": { "fontSize": "40px", "color": "#0f172a", "fontWeight": "800", "lineHeight": "1", "textAlign": "center" } },
                { "id": "min-s4l", "type": "text", "content": "Workshops", "style": { "fontSize": "14px", "color": "#64748b", "fontWeight": "500", "textAlign": "center" } }
              ],
              "style": { "padding": "30px 20px", "background": "transparent", "borderRadius": "8px", "display": "flex", "flexDirection": "column", "justifyContent": "center", "alignItems": "center", "alignSelf": "stretch", "gap": "6px" }
            }
          ],
          "style": { "padding": "0px", "background": "transparent", "borderRadius": "8px", "display": "flex", "flexDirection": "row", "justifyContent": "center", "alignItems": "stretch", "alignSelf": "stretch" },
          "responsiveStyles": { "mobile": { "flexDirection": "column" } }
        }
      ],
      "style": { "padding": "20px 20px", "background": "#ffffff", "minHeight": "100px", "borderTop": "1px solid #e2e8f0", "borderBottom": "1px solid #e2e8f0" },
      "type": "section",
      "layout": "boxed",
      "maxWidth": "900px"
    },
    {
      "id": "min-cta",
      "label": "CTA",
      "elements": [
        {
          "id": "min-cta-c",
          "type": "container",
          "orientation": "column",
          "children": [
            { "id": "min-cta-t1", "type": "text", "content": "Don't miss out.", "style": { "fontSize": "52px", "color": "#ffffff", "fontWeight": "800", "lineHeight": "1", "textAlign": "center" }, "responsiveStyles": { "mobile": { "fontSize": "36px" } } },
            { "id": "min-cta-t2", "type": "text", "content": "Seats are limited. Secure yours today.", "style": { "fontSize": "16px", "color": "rgba(255,255,255,0.8)", "fontWeight": "400", "textAlign": "center" } },
            { "id": "min-cta-b", "type": "button", "label": "Get Your Ticket", "href": "#", "style": { "background": "#ffffff", "color": "#1075BA", "borderRadius": "12px", "padding": "14px 36px", "fontSize": "15px", "fontWeight": "700" } }
          ],
          "style": { "padding": "20px", "background": "transparent", "borderRadius": "8px", "display": "flex", "flexDirection": "column", "justifyContent": "center", "alignItems": "center", "alignSelf": "stretch", "gap": "20px" }
        }
      ],
      "style": { "padding": "100px 20px", "background": "linear-gradient(135deg, #1075BA 0%, #1d5fbe 100%)", "minHeight": "200px" },
      "type": "section",
      "layout": "boxed",
      "maxWidth": "700px"
    }
  ],
};


export const PAGE_TEMPLATES = [webinarConference, minimalEvent];